import type { Locale } from '@seek/melways-sites';
import { useTranslations } from '@vocab/react';
import {
  Text,
  Box,
  IconAttachment,
  IconCompose,
  Inline,
  IconTick,
} from 'braid-design-system';
import { observer } from 'mobx-react';

import HotjarMask from 'src/components/common/HotjarMask';
import { TimeSinceAdded } from 'src/components/common/TimeAgo';

import translations from '../../.vocab';
import type { ItemType } from '../Item';

interface Props {
  user: string;
  date: string;
  locale: Locale;
  type: ItemType;
}

const ItemMeta = ({ user, date, locale, type }: Props) => {
  const { t } = useTranslations(translations);

  return (
    <Box alignItems="center" paddingTop="xxsmall" display="flex">
      <Inline space="xxsmall" alignY="center">
        <Text
          size="xsmall"
          tone="secondary"
          icon={
            type === 'attachment' ? (
              <IconAttachment tone="secondary" />
            ) : (
              <IconCompose tone="secondary" />
            )
          }
        >
          <HotjarMask>{`${user}`}</HotjarMask>
        </Text>
        <Text size="xsmall" tone="secondary">
          {`•`}
        </Text>

        <TimeSinceAdded
          date={date}
          locale={locale}
          size="xsmall"
          newMessageContent={
            <>
              <IconTick />
              {t('Added')}
            </>
          }
        />
      </Inline>
    </Box>
  );
};

export default observer(ItemMeta);
